var map = {
	"./symbol_0.png": 630,
	"./symbol_1.png": 78719,
	"./symbol_2.png": 48804,
	"./symbol_3.png": 91309,
	"./symbol_4.png": 9746,
	"./symbol_5.png": 58747,
	"./symbol_6.png": 3712,
	"./symbol_7.png": 74889,
	"./symbol_8.png": 59646,
	"./symbol_9.png": 47335
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13825;